<template>
  <div class="lg:ml-2 lg:mt-6 xl:ml-2 xl:mt-6 p-2 bg-gray-200 shadow-md">
    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('voorziening_typen')"
    >
      <i class="material-icons md-3xl mr-2">golf_course</i>
      <p>Voorzieningtypen</p>
    </div>
    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('ondergrond_typen')"
    >
      <i class="material-icons md-3xl mr-2">grass</i>
      <p>Ondergrondtypen</p>
    </div>
    <div
      class="flex flex-row cursor-pointer border-b border-gray-400 py-2"
      @click="loadPage('sport_typen')"
    >
      <i class="material-icons md-3xl mr-2">sports_soccer</i>
      <p>Sporten</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminMenu",
  methods: {
    loadPage: function(page) {
      this.$router.push({ name: "EditDomeinlijsten", params: { name: page } });
    }
  }
};
</script>

<style></style>
